import { render, staticRenderFns } from "./usersList.vue?vue&type=template&id=654cf27f&scoped=true"
import script from "./usersList.vue?vue&type=script&lang=js"
export * from "./usersList.vue?vue&type=script&lang=js"
import style0 from "./usersList.vue?vue&type=style&index=0&id=654cf27f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654cf27f",
  null
  
)

export default component.exports